import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MembershipsService } from 'src/app/services/memberships.service';
import * as globals from '../../globals';
import { AccountSelectorInputAsyncComponent } from '../../accounts/account-selector-input-async/account-selector-input-async.component';
import { Membership } from 'src/app/models/membership.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { first, firstValueFrom } from 'rxjs';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-membership-list',
  templateUrl: './membership-list.component.html',
  styleUrl: './membership-list.component.scss'
})

export class MembershipListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private snackBar: MatSnackBar,
    private membershipsService: MembershipsService,
    public dialog: MatDialog,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isAdministrator = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
  }

  private async deleteMembership(membership: Membership) {
    if(!this.isAdministrator) {
      return;
    }
    try {
      this.loadingSpinner(true);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          applicationId: this.accountSelectedId,
          dialogTitle: globals.membership_title,
          description: `${globals.DELETE_WARN} membership ${membership.name} from account ?`,
          cautionaryMessage: '',
          okButtonTitle: 'Remove',
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        this.membershipsService.deleteMembership(this.accountSelectedId, membership.name).subscribe({
          next: (data) => {
            this.loadingSpinner(false);
            this.showMessage(globals.member_removed_successfully);
            this.getMemberships(this.accountSelectedId);
          },
          error: (e) => {
            this.logger.logException(e);
            this.loadingSpinner(false);
            this.showMessage(globals.member_remove_failed);
          }
        });
      }
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  private getMemberships(accountId: number) {
    try {
      this.loadingSpinner(true);
      this.membershipsService.getMemberships(accountId).subscribe({
        next: (data) => {
          this.logger.logEvent('Membership Fetch Success', {accountId: accountId});
          this.dataSource = new MatTableDataSource(data);
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch {}
  }

  accountChanged = (accountId: number) => {
    this.accountSelectedId = accountId;
    this.refreshData();
  };

  accountCleared = () => this.accountSelectorInputAsyncComponent.clear();

  membershipAdded = (response) => this.refreshData();

  membershipCancelled = (response) => {};

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  private refreshData = () => this.getMemberships(this.accountSelectedId);

  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 5000 });

  isAdministrator: boolean;
  isLoading: boolean;
  accountSelectedId = 0;
  dataSource = new MatTableDataSource<Membership>();
  displayedColumns: string[] = globals.memberships_columns;
  
  @ViewChild(AccountSelectorInputAsyncComponent, { static: false }) accountSelectorInputAsyncComponent: AccountSelectorInputAsyncComponent;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
